import * as Yup from 'yup';

const addOnCategorySchema = Yup.object().shape({
  labelEn: Yup.string().required('English Label is required.'),
  labelAr: Yup.string().required('Arabic Label is required.'),
  position: Yup.number()
    .min(1, "Please enter more than 1")
    .typeError("Must be Number"),
});

export default addOnCategorySchema;